/**
 *  Component: Slack Mapping Fields
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import styled from 'styled-components';
import { MeshSelect } from 'styles/admin';
import { StyledIconButton } from 'styles/common';

import ConnectorLine from './connectorLine';

/* This is to fix zIndex issue for react select dropdowns */
const customStyles = {
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 9,
  }),
  container: (provided) => ({
    ...provided,
    marginTop: '9px',
  }),
};

const SlackMappingFields = ({ loading, saveFn, deleteFn, mapping, teams, channels }) => (
  <Grid container>
    <Grid item xs={5}>
      <MeshSelect
        styles={customStyles}
        menuPortalTarget={document.body}
        compact
        fullWidth
        placeholder="Select Team"
        isDisabled={loading}
        onChange={(data) => saveFn(data.value, 'team', mapping)}
        options={teams}
        name="team"
        value={mapping.teamId ? teams.filter((team) => team.value === mapping.teamId)[0] : {}}
      />
    </Grid>
    <Grid item xs={2} style={{ position: 'relative' }}>
      <ConnectorLine />
    </Grid>
    <Grid item xs={4}>
      <MeshSelect
        styles={customStyles}
        menuPortalTarget={document.body}
        compact
        fullWidth
        placeholder="Select Channel"
        isDisabled={loading}
        onChange={(data) => saveFn(data.value, 'channel', mapping)}
        options={channels}
        name="channel"
        value={
          mapping.thirdPartyTeamId ? channels.filter((channel) => channel.value === mapping.thirdPartyTeamId)[0] : {}
        }
      />
    </Grid>
    <Grid item xs={1}>
      <IconButton>
        <DeleteIcon onClick={() => deleteFn(mapping ? mapping.id : null)} />
      </IconButton>
    </Grid>
  </Grid>
);

const IconButton = styled(StyledIconButton)`
  display: table;
  margin: 14px auto 0 auto;
`;

export default SlackMappingFields;
